const ventureStudioFinalCtaParityTranslations = {
  ru: {
    'Explore ROMIND Academy': 'Изучить ROMIND Academy',
  },
  es: {
    'Explore ROMIND Academy': 'Explorar ROMIND Academy',
  },
  fr: {
    'Explore ROMIND Academy': 'Découvrir ROMIND Academy',
  },
  ko: {
    'Explore ROMIND Academy': 'ROMIND Academy 둘러보기',
  },
  ar: {
    'Explore ROMIND Academy': 'استكشف ROMIND Academy',
  },
};

export default ventureStudioFinalCtaParityTranslations;
